import { useEffect } from "react"

const CustomUseEffect = (callback, deps) =>{
    useEffect(()=>{
        callback()
    }, [...deps])
}

export default CustomUseEffect
